import type { ThreadHeaderProps } from 'stream-chat-react';

import './MessagingThreadHeader.css';

import { CloseThreadIcon } from '../../assets';

interface MessagingThreadHeaderProps extends ThreadHeaderProps {
  languageCode: any;
}

const MessagingThreadHeader = ({ closeThread, thread, languageCode }: MessagingThreadHeaderProps) => {
  /**
   * FUNCTION: getReplyCount
   * 
   * Formats reply count with correct plural form
   * 
   * RETURNS:
   * - "" (empty): No replies
   * - "1 Reply": Single reply
   * - "N Replies": Multiple replies
   */
  const getReplyCount = () => {
  
    if (!thread?.reply_count) return '';
    const count = thread.reply_count;
    if (count === 1) return `${count} ${languageCode.Reply || 'reply'}`;
   return `${count} ${languageCode.Replies || 'Replies'}`;
  };
  
  /**
   * RENDER
   * 
   * STRUCTURE:
   * - Left section: "Thread" title and reply count
   * - Right section: Close button
   */
  return (
    <div className='custom-thread-header'>
      <div className='custom-thread-header__left'>
        <p className='custom-thread-header__left-title'> {languageCode.Thread}</p>
        <p className='custom-thread-header__left-count'>{getReplyCount()}</p>
      </div>
      <CloseThreadIcon closeThread={closeThread} />
    </div>
  );
};

export default MessagingThreadHeader;
